// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__KCy9Z","logo":"NavBar_logo__NiPiR","menuGroup":"NavBar_menuGroup__3Dhh7","navLink":"NavBar_navLink__2LD_c"};